import { stepsContainerKey } from './';
export var createStepsContainerDriver = function (wrapper) {
    var base = wrapper.$("." + stepsContainerKey);
    return {
        itemCount: function () { return base.$$('.steps-container-item').count(); },
        dotsCount: function () { return base.$$('.dots').count(); },
        indexes: function () { return base.$$('.counter').text(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map